module.exports = __webpack_public_path__ + "img/joanna_erbel_22.5ddd3a70.png";